import React from 'react';
import Tooltip from '../../../../../../muiComponents/Tooltip';
import useTranslate from '../../../../../../customHooks/useTranslate';
import useLanguage from '../../../../../../customHooks/useLanguage';
import {
    formatRelativeTime,
    formatUTCDateTime,
} from '../../../../../../utils/formatDates';

interface ConnectivityLogsInfoTextProps {
    published: boolean;
    agenciesCount: number;
    lastConnection: Date | string | null;
    onGoToSettings: () => void;
}

const ConnectivityLogsInfoText = ({
    published,
    agenciesCount,
    lastConnection,
    onGoToSettings,
}: ConnectivityLogsInfoTextProps) => {
    const translate = useTranslate();
    const language = useLanguage();

    if (!published) {
        return (
            <p className='text-grey-600'>
                <span
                    className='cursor-pointer link-onhover'
                    onClick={onGoToSettings}
                >
                    {translate('publication_status_tooltip')}
                </span>
            </p>
        );
    }

    if (agenciesCount === 0) {
        return <p className='text-grey-600'>{translate('no_activity_logs')}</p>;
    }

    return (
        <p className='text-lowercase text-grey-600'>
            {`${agenciesCount} ${translate(
                agenciesCount === 1
                    ? 'tour_operator_connected'
                    : 'tour_operators_connected'
            )}`}{' '}
            ·{' '}
            <Tooltip title={formatUTCDateTime(lastConnection, language)}>
                <span>{`${translate('last_connection')} ${formatRelativeTime(
                    lastConnection,
                    language
                )}`}</span>
            </Tooltip>
        </p>
    );
};

export default ConnectivityLogsInfoText;
